import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';
import { pendingConnectClaimHref } from './pending-connect-claim';
import { useBasePath } from './use-base-path';
import { useOnboardingEntry } from './use-onboarding-entry';

// Its own module so `pending-connect-claim` stays import-free and unit-testable.
export function usePendingConnectClaimResume(): void {
  const router = useRouter();
  const basePath = useBasePath();
  const entry = useOnboardingEntry();
  const last = useRef<string | null>(null);
  useEffect(() => {
    if (!router.isReady) return;
    const href = pendingConnectClaimHref(router.pathname, entry.resolved);
    if (!href || href === last.current) return;
    last.current = href;
    void router.replace(href, `${basePath}${href}`);
  }, [router, basePath, entry.resolved]);
}
